import React from "react";
import { ConfidenceLevel } from "@/types/chat.types";

interface ConfidenceBadgeProps {
  confidence: ConfidenceLevel;
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ confidence }) => {
  const getBadgeStyles = () => {
    switch (confidence) {
      case "high":
        return "bg-ok-bg text-ok";
      case "medium":
        return "bg-warn-bg text-warn";
      case "low":
        return "bg-warn-bg text-warn";
      case "insufficient":
        return "bg-err-bg text-err";
      default:
        return "bg-surface-2 text-text-muted";
    }
  };

  const getLabel = () => {
    switch (confidence) {
      case "high":
        return "High Confidence";
      case "medium":
        return "Medium Confidence";
      case "low":
        return "Low Confidence";
      case "insufficient":
        return "Insufficient Data";
      default:
        return "Unknown";
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getBadgeStyles()}`}
    >
      {getLabel()}
    </span>
  );
};

export default ConfidenceBadge;
